import { frontendURL } from '../../../../helper/URLHelper';

const agentis  = accountId => ({
  parentNav: 'agentis', // This matches the key in your primary menu
  routes: [ 
    'agentis_test_environment',
    'agentis_create',
    'agentis_list',
    'agentis_adjustments'
  ],
  menuItems: [
    {
      icon: 'list',  // Choose an appropriate icon
      label: 'agentis_list',
      key: 'agentis_list',
      toState: frontendURL(`accounts/${accountId}/agentis/list`),
      toStateName: 'agentis_list',
    },
    {
      icon: 'agentis',  // Choose an appropriate icon
      label: 'agentis_create',
      key: 'agentis_create',
      toState: frontendURL(`accounts/${accountId}/agentis/create`),
      toStateName: 'agentis_create',
    },
    {
      icon: 'wand',  // Magic wand icon for intelligent adjustments
      label: 'agentis_adjustments',
      key: 'agentis_adjustments',
      toState: frontendURL(`accounts/${accountId}/agentis/adjustments`),
      toStateName: 'agentis_adjustments',
    }//,
    //{
    //  icon: 'agentis',  // Choose an appropriate icon
    //  label: 'agentis_test_environment',
    //  key: 'agentis_test_environment',
    //  toState: frontendURL(`accounts/${accountId}/agentis/test-environment`),
    //  toStateName: 'agentis_test_environment',
    //}
  ],
});

export default agentis;

